"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getElementSize(domElement) {
    // Get fractional size when on DOM
    if (domElement.getBoundingClientRect instanceof Function) {
        var rect = domElement.getBoundingClientRect();
        return { x: rect.width, y: rect.height };
    }
    // Fallback to rounded offsetWidth/offsetHeight
    if (domElement.offsetWidth !== undefined) {
        return { x: domElement.offsetWidth, y: domElement.offsetHeight };
    }
    return { x: 1, y: 1 };
}
exports.default = getElementSize;
//# sourceMappingURL=getElementSize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/renderers/dom/getElementSize.js
// module id = 146
// module chunks = 35783957827783 127651196306611 162898551421021